import { render, staticRenderFns } from "./plmEcn.vue?vue&type=template&id=2a1f9aa4&scoped=true"
import script from "./plmEcn.vue?vue&type=script&lang=js"
export * from "./plmEcn.vue?vue&type=script&lang=js"
import style0 from "./plmEcn.vue?vue&type=style&index=0&id=2a1f9aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1f9aa4",
  null
  
)

export default component.exports